import { Fade, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { officeAuth } from "../../redux/Login/LoginActionCreators";
import Store from "../../redux/Store";
import Map from "../../components/Map";
import { useStyles } from "../../styles/mainStyles";

const OfficeInfo = () => {
  const history = useHistory();

  const clear = () => {
    history.push("/");
    localStorage.clear();
    Store.dispatch(officeAuth(false));
  };
  let border = useStyles();
  let profile;
  try {
    profile = JSON.parse(localStorage.profile);
  } catch (error) {
    clear();
  }

  return (
    <Fade in={true} timeout={500}>
      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        spacing={2}
        style={{ margin: "auto", height: "100%" }}
      >
        <Grid
          item
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ height: 50 }}
        >
          <Typography variant="body1">پروفایل من</Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={border.border}
          style={{ height: "calc(100% - 50px)", margin: 8 }}
        >
          {/* Info Right Section */}
          <Grid item xs={6} style={{}} container>
            <Grid item xs={4}>
              {list1.map((item, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{ padding: "8px", height: "3em" }}
                >
                  {item.title} :
                </Typography>
              ))}
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.board_title : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.office_number : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.office_number : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.start_work_time : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.end_work_time : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                ایران
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.address.state : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.address.city : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined
                  ? profile.address.addresses[0].formatted
                  : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined
                  ? profile.address.neighbourhood
                  : clear()}
              </Typography>
              <Typography
                variant="body2"
                style={{ padding: "8px", height: "3em" }}
              >
                {profile !== undefined ? profile.pocode : clear()}
              </Typography>
            </Grid>
          </Grid>
          {/*------------------------------------------------------------------------ Info left Section */}
          <Grid item xs={6} container spacing={2} style={{ margin: "auto" }}>
            <Grid item xs={12} container direction="row" style={{}}>
              <Grid item xs={6}>
                {list2.map((item, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    style={{ padding: "8px" }}
                  >
                    {item} :
                  </Typography>
                ))}
              </Grid>
              <Grid item xs={6}>
                {list2.map((item, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    style={{ padding: "8px" }}
                  >
                    {null}
                  </Typography>
                ))}
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              justifyContent="center"
              container
              style={{ paddingBottom: "10px" }}
            >
              <Map lat={profile.lat} lng={profile.lng} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default OfficeInfo;
const list1 = [
  { title: "نام دفتر", name: "board_title" },
  { title: "شماره دفتر", name: "office_number" },
  { title: "شماره ثابت دفتر", name: "" },
  { title: "ساعت شروع کاری", name: "start_work_time" },
  { title: "ساعت پایان کاری", name: "end_work_time" },
  { title: "کشور", name: "" },
  { title: "استان", name: "state" },
  { title: "شهر", name: "city" },
  { title: "آدرس", name: "" },
  { title: "جزئیات آدرس", name: "" },
  { title: "کد پستی", name: "pocode" },
];
const list2 = ["شماره پیگیری", "تاریخ درخواست", "تاریخ تایید", "وضعیت"];
